let Widget3dsoft = require('./Main.js');

Widget3dsoft.prototype.beforeSendAjax = function (xhr, self) {
   xhr.setRequestHeader("Authorization", "BEARER " + self.sJWT);
};

Widget3dsoft.prototype.ajax = function (sType, sUrl, aData, fCallback,bJson) {
    var self = this;
    var Debut = new Date();
    $(self.sClass + ' .widget3Dsoft-loading').show();
    self.bAjaxTermine3Dsoft = false;
    var self = this;
    if(bJson){
        dataType ="json";
    }else{
        dataType = "html";
    }
    
    if(self.profilerActif){
        console.log(sType + ' (' + dataType + ') : ' + sUrl);
    }
    
    if (bIEOld3Dsoft) {
        
          //AJAX WITH IE < 10
          var oXDomainRequest = new window.XDomainRequest();
                oXDomainRequest.onprogress = function() {}; // no aborting
                oXDomainRequest.ontimeout = function() {}; // "
                oXDomainRequest.onload = function() {
                    
                    //Profiling
                    var Fin = new Date();
                    if(self.profilerActif){
                        console.log('Temps d\'execution de ' + sUrl + ' : ',(Fin - Debut) + " ms.");
                    }
                    $(self.sClass).addClass('widget-3dsoft');
                    //Response
                    fCallback(oXDomainRequest.responseText);
                    hideLoading(self);
                };
                oXDomainRequest.onerror = function(e) {
                    // error handling
                    console.log(e);
                };
                aData.jwt = "BEARER " + self.sJWT;
                oXDomainRequest.open("POST",sUrl, true);
                oXDomainRequest.send(JSON.stringify(aData));

    } else {
        
        //AJAX
        $.support.cors = true;
        $.ajax({
            type: sType,
            url: sUrl,
            data: aData,
            dataType : dataType,
            beforeSend: function (xhr) {
                self.beforeSendAjax(xhr, self)
            },
            success: function (response, statut) {
                //Profiling
                var Fin = new Date();
                if(self.profilerActif){
                    console.log('Temps d\'execution de ' + sType + ':'+sUrl + ' : ',(Fin - Debut) + " ms.");
                }
                $(self.sClass).addClass('widget-3dsoft');
                fCallback(response, statut);
                hideLoading(self);
            },
            error: function (resultat, statut, erreur) {
                hideLoading(self);
                console.log('type : ', sType);
                console.log('url : ', sUrl);
                console.log('data : ', aData);
                console.log('dataType : ', dataType);
                console.log('resultat : ', resultat);
                console.log('statut : ', statut);
                console.log('erreur : ', erreur);
            }
        });
    }

    iCptWait3Dsoft = 0;
};

function hideLoading(self) {
    if (!self.bAjaxTermine3Dsoft && iCptWait3Dsoft < 15) {
        iCptWait3Dsoft++;
        setTimeout(function(){hideLoading(self);}, 5000);
    } else {
        $(self.sClass + ' .widget3Dsoft-loading').hide();
    }
}

module.exports = Widget3dsoft;